'use strict';

var splice = [].splice;
module.exports = splice;